import "firebase/firebase-database";
import "firebase/auth";
import * as firebase from "firebase/app";
import { FirebaseAuthAPI } from "../../..";

class CoreFirebaseAPI {
  constructor(path) {
    this.initFireBase();
    this.setRef(path);
  }

  async singInFireBase() {
    try {
      const resp = await FirebaseAuthAPI.postAutentication();

      if (resp && resp.data && resp.data.access_token) {
        firebase.auth().signInWithCustomToken(resp.data.access_token);
      }
    } catch (error) {
      console.log(error);
    }
  }

  async initFireBase() {
    const config = {
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
      measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    };

    if (firebase && firebase.apps && !firebase.apps.length) {
      firebase.initializeApp(config);
    }

    if (firebase && firebase.apps && !firebase.auth().currentUser) {
      await this.singInFireBase();
    }
  }

  setRef(path) {
    this.ref = firebase.database().ref(path);
  }

  getInstance() {
    return this.ref;
  }
}

export default CoreFirebaseAPI;
